/* ==========================================================================
   SeaWolves Apparel — main.js
   ========================================================================== */
(function () {
  'use strict';

  // The loader snippet may be rendered by several sections on one page.
  // Browsers dedupe identical script URLs, but guard anyway.
  if (window.__seaWolvesInit) return;
  window.__seaWolvesInit = true;

  var lockCount = 0;
  function lock()   { lockCount++; document.body.classList.add('is-locked'); }
  function unlock() { lockCount = Math.max(0, lockCount - 1); if (!lockCount) document.body.classList.remove('is-locked'); }

  /* --------------------------------------------------------------
     Mobile drawer
     -------------------------------------------------------------- */
  function initDrawer() {
    var open   = document.querySelector('[data-drawer-open]');
    if (open && open.dataset.swBound) return;
    if (open) open.dataset.swBound = '1';
    var close  = document.querySelector('[data-drawer-close]');
    var drawer = document.querySelector('[data-drawer]');
    var scrim  = document.querySelector('[data-scrim]');
    if (!open || !drawer) return;

    var lastFocus = null;

    function show() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      if (scrim) scrim.classList.add('is-open');
      open.setAttribute('aria-expanded', 'true');
      lock();
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    }

    function hide() {
      if (!drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      if (scrim) scrim.classList.remove('is-open');
      open.setAttribute('aria-expanded', 'false');
      unlock();
      if (lastFocus) lastFocus.focus();
    }

    open.addEventListener('click', show);
    if (close) close.addEventListener('click', hide);
    if (scrim) scrim.addEventListener('click', hide);

    drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', hide); });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });

    var mq = window.matchMedia('(min-width: 1025px)');
    (mq.addEventListener ? mq.addEventListener.bind(mq, 'change') : mq.addListener.bind(mq))(function (e) {
      if (e.matches) hide();
    });
  }

  /* --------------------------------------------------------------
     Filter panel (collections page, mobile)
     -------------------------------------------------------------- */
  function initFilters() {
    var open    = document.querySelector('[data-filters-open]');
    if (open && open.dataset.swBound) return;
    if (open) open.dataset.swBound = '1';
    var closers = document.querySelectorAll('[data-filters-close]');
    var panel   = document.querySelector('[data-filters]');
    if (!open || !panel) return;

    function show() { panel.classList.add('is-open'); open.setAttribute('aria-expanded', 'true'); lock(); }
    function hide() {
      if (!panel.classList.contains('is-open')) return;
      panel.classList.remove('is-open');
      open.setAttribute('aria-expanded', 'false');
      unlock();
    }

    open.addEventListener('click', show);
    closers.forEach(function (c) { c.addEventListener('click', hide); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });

    var mq = window.matchMedia('(min-width: 901px)');
    (mq.addEventListener ? mq.addEventListener.bind(mq, 'change') : mq.addListener.bind(mq))(function (e) {
      if (e.matches) hide();
    });
  }

  /* --------------------------------------------------------------
     Toggle-style controls that are NOT backed by a real input.
     On Shopify the filter swatches/sizes are <label>+<input> pairs
     and the browser handles state, so we skip those.
     -------------------------------------------------------------- */
  function initToggles() {
    document.querySelectorAll('.size, .swatch').forEach(function (el) {
      if (el.tagName === 'LABEL') return;              // real form control
      if (el.closest('#sw-filter-form')) return;       // Shopify filter form
      if (el.dataset.swBound) return;
      el.dataset.swBound = '1';
      el.addEventListener('click', function () { el.classList.toggle('is-active'); });
    });
  }

  /* --------------------------------------------------------------
     FAQ / accordion
     -------------------------------------------------------------- */
  function initFaq() {
    var items = document.querySelectorAll('[data-faq-item]');
    if (!items.length) return;

    function closeItem(item) {
      item.classList.remove('is-open');
      var p = item.querySelector('[data-faq-a]');
      var b = item.querySelector('[data-faq-q]');
      if (p) p.style.maxHeight = null;
      if (b) b.setAttribute('aria-expanded', 'false');
    }

    items.forEach(function (item) {
      var btn   = item.querySelector('[data-faq-q]');
      var panel = item.querySelector('[data-faq-a]');
      if (!btn || !panel) return;
      if (btn.dataset.swBound) return;
      btn.dataset.swBound = '1';

      btn.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        items.forEach(closeItem);
        if (!wasOpen) {
          item.classList.add('is-open');
          panel.style.maxHeight = panel.scrollHeight + 48 + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // Keep an open panel correctly sized on resize
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        document.querySelectorAll('[data-faq-item].is-open').forEach(function (item) {
          var p = item.querySelector('[data-faq-a]');
          if (p) p.style.maxHeight = p.scrollHeight + 48 + 'px';
        });
      }, 150);
    });
  }

  /* --------------------------------------------------------------
     Client-side validation for demo forms only.

     Shopify's own {% form %} tags post to the platform and must NOT
     be intercepted, so we only bind to elements carrying data-form.
     -------------------------------------------------------------- */
  function isEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }

  function setMsg(el, text, ok) {
    if (!el) return;
    el.textContent = text;
    el.classList.remove('is-ok', 'is-err');
    el.classList.add(ok ? 'is-ok' : 'is-err');
  }

  function initForms() {
    document.querySelectorAll('form[data-form]').forEach(function (form) {
      if (form.dataset.swBound) return;
      form.dataset.swBound = '1';
      var msg = form.querySelector('[data-form-msg]');
      var hp  = form.querySelector('[data-hp]');

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (hp && hp.value) return;          // honeypot tripped

        var missing = null;
        form.querySelectorAll('[required]').forEach(function (f) {
          if (!missing && !f.value.trim()) missing = f;
        });
        if (missing) {
          setMsg(msg, 'Please fill in the required fields.', false);
          missing.focus();
          return;
        }

        var email = form.querySelector('input[type="email"]');
        if (email && !isEmail(email.value.trim())) {
          setMsg(msg, 'Please enter a valid email address.', false);
          email.focus();
          return;
        }

        setMsg(msg, form.getAttribute('data-success') || 'Thanks — we got it.', true);
        form.reset();
      });
    });
  }

  /* --------------------------------------------------------------
     Scroll reveal
     -------------------------------------------------------------- */
  function initReveal() {
    var els = document.querySelectorAll('.rv');
    if (!els.length) return;

    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  /* --------------------------------------------------------------
     Boot
     -------------------------------------------------------------- */
  function boot() {
    initDrawer();
    initFilters();
    initToggles();
    initFaq();
    initForms();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify theme editor: re-bind when a section is added, moved or updated.
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:reorder', boot);
})();
